import { render, staticRenderFns } from "./RasioAdd.vue?vue&type=template&id=7671b418&scoped=true"
import script from "./RasioAdd.vue?vue&type=script&lang=js"
export * from "./RasioAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671b418",
  null
  
)

export default component.exports